import LoadingButton from "@mui/lab/LoadingButton";
import { useEffect, useState } from "react";
import { Save } from '@mui/icons-material';
import { Box, FormControl, FormLabel, MenuItem, Select, TextField } from "@mui/material";
import { API_HOST, BE_HOST, JENIS_BAYAR, METODE_PEMBAYARAN } from "../../helper/Constant";
import { Commons } from "../../helper/CommonService";
import ShowNotif from "../general/ShowNotif";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';

function BayarPendaftaran({ idSantri, dataBayar, typeBayar }) {
    const [data, setData] = useState(dataBayar);
    const [processing, setProcessing] = useState(false);
    const [isShowNotif, setIsShowNotif] = useState(false);
    const [notifData, setNotifData] = useState({});

    const UpdateData = (propertyName, propertyValue) => {
        setData(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const UpdatePembayaran = () => {
        setProcessing(true);
        let formData = data;
        formData["data_santri"] = idSantri;
        formData["type"] = typeBayar;
        Commons.PostData(API_HOST + '/items/pembayarans', formData, true)
            .then((responseData) => {
                setNotifData({
                    "status": "success",
                    "message": "Update data successfully"
                });
            })
            .catch((responseError) => {
                setNotifData({
                    "status": "error",
                    "message": "Update data gagal"
                });
            })
            .finally(() => {
                setIsShowNotif(true);
                setProcessing(false);
            });
    }

    return (
        <>
            <Box sx={{ mt: 3 }}>
                <ShowNotif isShow={isShowNotif} data={notifData} actionClose={() => { setIsShowNotif(false); }}></ShowNotif>
                <FormControl fullWidth>
                    <FormLabel sx={{
                        color: "#000000", fontWeight: "bold", marginTop: "15px"
                    }}>Nominal</FormLabel>
                    <TextField value={data?.nominal || ''} name='nominal' onChange={(e) => { UpdateData(e.target.name, e.target.value) }} fullWidth></TextField>

                    <FormLabel sx={{
                        color: "#000000", fontWeight: "bold", marginTop: "15px"
                    }}>
                        No Kuitansi (Optional)</FormLabel>
                    <TextField value={data?.no_kuitansi} name='no_kuitansi' onChange={(e) => { UpdateData(e.target.name, e.target.value) }} fullWidth></TextField>

                    <FormLabel sx={{
                        color: "#000000", fontWeight: "bold", marginTop: "15px"
                    }}>Tanggal Pembayaran</FormLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker format="DD/MM/YYYY" value={(data?.tanggal) ? dayjs(data.tanggal) : null} onChange={(e) => { UpdateData("tanggal", e) }} name='tanggal'>
                        </DatePicker>
                    </LocalizationProvider>

                    <FormLabel sx={{ color: "#000000", fontWeight: "bold", marginTop: "15px" }}>
                        Type Pembayaran</FormLabel>
                    <Select name="metode" onChange={(e) => { UpdateData(e.target.name, e.target.value) }} value={data?.metode} fullWidth>
                        {
                            Object.entries(METODE_PEMBAYARAN).map(([key, value]) => {
                                return (
                                    <MenuItem value={value} key={key}>{value}</MenuItem>
                                )
                            })
                        }
                    </Select>

                    <FormLabel sx={{
                        color: "#000000", fontWeight: "bold", marginTop: "15px"
                    }}>Catatan</FormLabel>
                    <TextField name="catatan" onChange={(e) => { UpdateData(e.target.name, e.target.value) }} multiline rows={3} value={data?.catatan} fullWidth></TextField>

                    <LoadingButton
                        loading={processing}
                        loadingPosition="start"
                        style={{ backgroundColor: "#e96726", color: "white", marginTop: "15px" }}
                        startIcon={<Save />}
                        variant="outlined"
                        fullWidth
                        onClick={(e) => {
                            UpdatePembayaran();
                        }}
                    >
                        {processing ? "Processing" : "Update Pembayaran"}
                    </LoadingButton>
                </FormControl>
            </Box>
        </>
    )
}

export default BayarPendaftaran;